/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrendingNotificationActionData
 */
export interface TrendingNotificationActionData {
    /**
     * 
     * @type {number}
     * @memberof TrendingNotificationActionData
     */
    rank: number;
    /**
     * 
     * @type {string}
     * @memberof TrendingNotificationActionData
     */
    genre: string;
    /**
     * 
     * @type {string}
     * @memberof TrendingNotificationActionData
     */
    trackId: string;
    /**
     * 
     * @type {string}
     * @memberof TrendingNotificationActionData
     */
    timeRange: TrendingNotificationActionDataTimeRangeEnum;
}


/**
 * @export
 */
export const TrendingNotificationActionDataTimeRangeEnum = {
    Week: 'week',
    Month: 'month',
    Year: 'year'
} as const;
export type TrendingNotificationActionDataTimeRangeEnum = typeof TrendingNotificationActionDataTimeRangeEnum[keyof typeof TrendingNotificationActionDataTimeRangeEnum];


/**
 * Check if a given object implements the TrendingNotificationActionData interface.
 */
export function instanceOfTrendingNotificationActionData(value: object): value is TrendingNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "rank" in value && value["rank"] !== undefined;
    isInstance = isInstance && "genre" in value && value["genre"] !== undefined;
    isInstance = isInstance && "trackId" in value && value["trackId"] !== undefined;
    isInstance = isInstance && "timeRange" in value && value["timeRange"] !== undefined;

    return isInstance;
}

export function TrendingNotificationActionDataFromJSON(json: any): TrendingNotificationActionData {
    return TrendingNotificationActionDataFromJSONTyped(json, false);
}

export function TrendingNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrendingNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rank': json['rank'],
        'genre': json['genre'],
        'trackId': json['track_id'],
        'timeRange': json['time_range'],
    };
}

export function TrendingNotificationActionDataToJSON(value?: TrendingNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rank': value.rank,
        'genre': value.genre,
        'track_id': value.trackId,
        'time_range': value.timeRange,
    };
}

